import React from 'react'
import { Modal } from 'react-bootstrap'
import deleteIcon from "../../assets/images/delete.svg"
import { useTranslation } from 'react-i18next';
// import deleteIcon from "../../assets/icons/delete.png"
 
const DeleteModal = ({
    closeModal = () => { },
    handleDelete = () => { },
    show = false,
    deleteName = "",
    deleteTtpe = "",
    deleteTitle = ""
}) => {
    const { t } = useTranslation();
 
    return (
        <div>
            <Modal size={'md'} show={show} onHide={closeModal} centered >
                <Modal.Body className='custom-modal' style={{ borderRadius: "inherit" }}>
                    <div>
                        <div className="text-center col-12">
                            <div className='my-3'>
                                <img src={deleteIcon} alt="" height={30} width={30} />
                            </div>
                            <div className="fw-6 font-18 black-color"> {` ${deleteTtpe} ${deleteTitle}`}</div >
                            <div className="grey-color1 font-15 my-2 " >
                                {`${t("messageText.youAreAboutTo")} `}{deleteTtpe?.toLowerCase()}  <span className='blue-color5'>{deleteName?.toLowerCase()}</span><br /> {t("messageText.sure")}
                            </div>
                        </div>
                        <div className="d-flex justify-content-center py-4">
                            <button className="custom_button bg-red-color2 white-color font-14 px-5 py-2" onClick={() => handleDelete("YES")} >{deleteTtpe}</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}
 
export default DeleteModal